/**
 * 設計系統 KPI 卡（對應 docs/cms-screens 之 Component/KpiCard）。
 *
 * 樣式由 index.css 之 .kpi-card / .kpi-card__* 提供。
 */
interface KpiCardProps {
  label: string;
  value: string;
  /** 趨勢說明文字（如「較昨日 +12.4%」）；省略則不顯示 */
  trend?: string;
  /** 趨勢方向 — 決定 trend 文字顏色 */
  trendDir?: 'up' | 'down';
}

export function KpiCard({ label, value, trend, trendDir }: KpiCardProps): JSX.Element {
  return (
    <div className="kpi-card">
      <div className="kpi-card__label">{label}</div>
      <div className="kpi-card__value">{value}</div>
      {trend !== undefined && (
        <div className={`kpi-card__trend${trendDir ? ` ${trendDir}` : ''}`}>{trend}</div>
      )}
    </div>
  );
}
